<div class="copyright">
  <div>
    <span>Picture copyrights</span>
    <span>Len Lye Centre, New Zealand</span>
    <span>Patterson Associates Architects</span>
    <span>Photo by Patrick Reynolds</span>
  </div>
  
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16">
    <path fill="#fff" fill-rule="evenodd" d="M7442,552a8,8,0,1,1,8-8A8,8,0,0,1,7442,552Zm0-13a5,5,0,1,0,4.9,6h-2.08a3,3,0,1,1,0-2h2.08A5,5,0,0,0,7442,539Z" transform="translate(-7434 -536)"/>
  </svg>
</div>
